import { useReducer } from 'react'

// State.status

export const statusTypes = {
  idle: 'IDLE',
  error: 'ERROR',
  limit: 'LIMIT',
  loading: 'LOADING',
  noMoreReservations: 'NO_MORE_RESERVATIONS',
  noReservations: 'NO_RESERVATIONS',
}

// Action.type

export const actionTypes = {
  fetchStart: 'FETCH_START',
  fetchSuccess: 'FETCH_SUCCESS',
  fetchError: 'FETCH_ERROR',
  reachedEnd: 'REACHED_END',
  gotLimit: 'GOT_LIMIT',
  gotNone: 'GOT_NONE',
  reset: 'RESET',
}

function reservationsReducer(state, action) {
  const actionUserReservations =
    action === undefined || action.payload === undefined ? null : action.payload.userReservations

  switch (state.status) {
    case 'IDLE':
    case 'ERROR': {
      if (action.type === 'RESET') {
        return {
          ...state,
          status: 'IDLE',
          showOnlyCompletedOrdinances: action.payload.showOnlyCompletedOrdinances,
          payload: {
            userReservations: { reservations: [] },
            reservationIndex: 0,
          },
        }
      }
      return action.type === actionTypes.fetchStart ? { ...state, status: 'LOADING' } : state
    }

    case 'LOADING': {
      switch (action.type) {
        case 'FETCH_SUCCESS': {
          const totalReservations = state.payload.reservationIndex + actionUserReservations.reservations.length
          return {
            ...state,
            status: totalReservations >= state.scrollLimit ? 'LIMIT' : 'IDLE',
            payload: {
              userReservations: {
                reservations: [...state.payload.userReservations.reservations, ...actionUserReservations.reservations],
                personData: {
                  ...state.payload.userReservations.personData,
                  ...actionUserReservations.personData,
                },
                hasMoreReservations: actionUserReservations.hasMoreReservations,
                userName: actionUserReservations.userNames[state.contributorId],
                totalPidCount: action.payload.totalReservationCount,
              },
              reservationIndex: totalReservations,
            },
          }
        }

        case 'FETCH_ERROR': {
          return { ...state, status: 'ERROR' }
        }

        case 'GOT_LIMIT':
        case 'REACHED_END': {
          const newIndex = actionUserReservations.reservations != null ? actionUserReservations.reservations.length : 0
          state.status = action.type === 'REACHED_END' ? 'NO_MORE_RESERVATIONS' : 'LIMIT'
          if (newIndex > 0) {
            return {
              ...state,
              payload: {
                userReservations: {
                  reservations: [
                    ...state.payload.userReservations.reservations,
                    ...actionUserReservations.reservations,
                  ],
                  personData: {
                    ...state.payload.userReservations.personData,
                    ...actionUserReservations.personData,
                  },
                  hasMoreReservations: actionUserReservations.hasMoreReservations,
                  userName: actionUserReservations.userNames[state.contributorId],
                  totalPidCount: action.payload.totalReservationCount,
                },
                reservationIndex: state.payload.reservationIndex + newIndex,
              },
            }
          }
          return {
            ...state,
            payload: {
              userReservations: {
                reservations: [...state.payload.userReservations.reservations],
                personData: {
                  ...state.payload.userReservations.personData,
                },
                hasMoreReservations: actionUserReservations.hasMoreReservations,
                userName: actionUserReservations.userNames[state.contributorId],
                totalPidCount: action.payload.totalReservationCount,
              },
              reservationIndex: state.payload.reservationIndex,
            },
          }
        }

        case 'GOT_NONE': {
          return { ...state, status: 'NO_RESERVATIONS' }
        }

        default: {
          return { ...state }
        }
      }
    }

    default: {
      if (action.type === 'RESET') {
        return {
          ...state,
          status: 'IDLE',
          showOnlyCompletedOrdinances: action.showOnlyCompletedOrdinances,
          payload: {
            userReservations: { reservations: [] },
            reservationIndex: 0,
          },
        }
      }
      return { ...state }
    }
  }
}

export default function useUserReservationsReducer(reservationInitialState) {
  const [state, dispatch] = useReducer(reservationsReducer, reservationInitialState)

  return { state, dispatch }
}
